module.exports = __webpack_public_path__ + "img/fpzl.90c986ed.png";